<template>
	<div class="body">
		<el-container>
			
			<el-header>
				<HeaderCus></HeaderCus>
			</el-header>
			
			<el-main>
				<div class="content_main">
					<div class="mbxdh">
						<el-breadcrumb separator-class="el-icon-arrow-right">
						  <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
						  
						  <el-breadcrumb-item :to="{ path: '/list_statis_wenda'}">问询答复统计</el-breadcrumb-item>
						  
						  <!-- <el-breadcrumb-item v-if="daqu == 1">大区A</el-breadcrumb-item>
						  <el-breadcrumb-item v-if="daqu == 2">大区B</el-breadcrumb-item> -->
						  <!-- <el-breadcrumb-item v-if="tuwen_type == 43">知识产权工具</el-breadcrumb-item>
						  <el-breadcrumb-item v-if="tuwen_type == 45">知识产权案例</el-breadcrumb-item> -->
						  
						</el-breadcrumb>
					</div>
					
					<div class="nrqy">
						
						<el-row class="tiaojian_elrow" style="margin-top: -10px;">
							<el-col :span="2">
								<div class="tiaojian_line_row_left">
									按地区：
								</div>
							</el-col>
							<el-col :span="21">
								<div class="tiaojian_line_row_right">
									<el-tag size="small" :type="list_prov_type[0]" @click="clickDiqu(0, 0)">不限</el-tag>
									<el-dropdown size="small" placement="top-end" @command="selectProv">
										<span class="el-dropdown-link">
											{{prov_text}}<i class="el-icon-arrow-down el-icon--right"></i>
										</span>
										<el-dropdown-menu slot="dropdown">
											<el-dropdown-item command="0">不限省份</el-dropdown-item>
											<el-dropdown-item v-for="(item, index) in list_prov" :key="index" :command="item.id">
												{{item.name}}
											</el-dropdown-item>
										</el-dropdown-menu>
									</el-dropdown>
									<el-dropdown size="small" placement="top-end" @command="selectCity">
										<span class="el-dropdown-link">
											{{city_text}}<i class="el-icon-arrow-down el-icon--right"></i>
										</span>
										<el-dropdown-menu slot="dropdown">
											<el-dropdown-item command="0">不限地市</el-dropdown-item>
											<el-dropdown-item v-for="(item, index) in list_city" :key="index" :command="item.id">
												{{item.name}}
											</el-dropdown-item>
										</el-dropdown-menu>
									</el-dropdown>
								</div>
							</el-col>
						</el-row>
						
						
						<el-row class="tiaojian_elrow">
							<el-col :span="2">
								<div class="tiaojian_line_row_left">
									按领域：
								</div>
							</el-col>
							<el-col :span="21">
								<div class="tiaojian_line_row_right">
									<el-tag size="small" :type="list_lingyu_type[0]" @click="clickLingyu(0, 0)">不限</el-tag>
									<el-tag size="small" v-for="(item, index) in list_lingyu" :key="index" :type="list_lingyu_type[index+1]" @click="clickLingyu(index+1, item.dictValue)">{{item.dictLabel}}</el-tag>
								</div>
							</el-col>
						</el-row>
						
						<el-row class="tiaojian_elrow">
							<el-col :span="2">
								<div class="tiaojian_line_row_left">
									按年份：
								</div>
							</el-col>
							<el-col :span="21">
								<div class="tiaojian_line_row_right">
									<el-tag size="small" :type="list_year_type[0]" @click="clickYear(0, 0)">不限</el-tag>
									<el-tag size="small" v-for="(item, index) in list_year" :key="index" :type="list_year_type[index+1]" @click="clickYear(index+1, item.dictValue)">{{item.dictLabel}}</el-tag>
								</div>
							</el-col>
						</el-row>
						<el-row class="tiaojian_elrow" v-show="is_show_month">
							<el-col :span="2" :push="1">
								<div class="tiaojian_line_row_left" style="font-size: 13px;">
									按月份：
								</div>
							</el-col>
							<el-col :span="20" :push="1">
								<div class="tiaojian_line_row_right">
									<el-tag size="small" :type="list_month_type[0]" @click="clickMonth(0, 0)">不限</el-tag>
									<el-tag size="small" v-for="(item, index) in list_month" :key="index" :type="list_month_type[index+1]" @click="clickMonth(index+1, item.dictValue)">{{item.dictLabel}}</el-tag>
								</div>
							</el-col>
						</el-row>
						
						<!-- <el-row class="tiaojian_elrow">
							<el-col :span="2">
								<div class="tiaojian_line_row_left">
									按类型：
								</div>
							</el-col>
							<el-col :span="21">
								<div class="tiaojian_line_row_right">
									<el-tag size="small" :type="list_fx_leixing_type[0]" @click="clickFxleixing(0, 0)">不限</el-tag>
									<el-tag size="small" v-for="(item, index) in list_fx_leixing" :key="index" :type="list_fx_leixing_type[index+1]" @click="clickFxleixing(index+1, item.dictValue)">{{item.dictLabel}}</el-tag>
								</div>
							</el-col>
						</el-row> -->
						
						<el-row class="tiaojian_elrow" style="border: 0px;">
							<el-col :span="21" :push="1">
								<div class="tiaojian_line_row_right">
									<el-input
										placeholder="请输入关键词搜索..."
										prefix-icon="el-icon-search"
										style="width: 40%;"
										v-model="keyword"
										:clearable="true"
										@clear="clearInput"
										>
									</el-input>
									<el-button type="primary" size="medium" @click="doSearch" v-loading.fullscreen.lock="fullscreenLoading">搜索</el-button>
									<span class="span_search_result">检索到{{total}}条数据</span>
								</div>
							</el-col>
						</el-row>
						
					</div>
					
					<div class="neirong_line">
						<div class="neirong_line_left" style="width: 96%;">
							
							<el-empty description="没找到你想要的数据..." v-show="is_show_empty"></el-empty>
							
							<el-row>
								<div class="statis_line_out">
									<div class="statis_line_inner">
										<div class="statis_line_header" style="width: 300px; position:absolute; background: #fff">
											企业名称 <span style="color: #777; font-size: 12px;">(涉及问询企业数/当前企业总数)</span>
										</div>
										<div style="margin-left: 300px;">
											<div class="statis_line_header" v-for="(item, index) in list_wenda_kw" :key="index" style="width: 90px; font-size: 13px">
												<span style=" cursor: pointer;" @click="toUrl('list_statis_wenda_filter?typeid=' + item.id)">
													{{item.keyword}}
												</span>
												<el-tooltip class="item" effect="dark" :content="item.frontRemark" placement="bottom">
													<i class="el-icon-info"></i>
												</el-tooltip>
											</div>
										</div>
										
									</div>
									<div class="statis_line_inner" v-for="(item, index) in list_record" :key="index">
										<div class="statis_line_content" style="width: 300px; position:absolute; background: #fff">
											{{item.name}}
										</div>
										<div style="margin-left: 300px;">
											<span v-for="(itemHas, indexHas) in item.keywordIsHas" :key="indexHas">
												<div class="statis_line_content" v-if='itemHas == 0' style="width: 90px;">
													<i class="el-icon-success" style="color: green;"></i>
												</div>
												<div class="statis_line_content" v-if='itemHas == 1' style="width: 90px;">
													<i class="el-icon-error" style="color: red;"></i>
												</div>
											</span>
										</div>
									</div>
								</div>
							</el-row>
							
							<div class="neirong_line_split"></div>
							
							<div class="neirong_line_page">
								<el-pagination
								  background
								  layout="prev, pager, next, jumper"
								  :page-size="7"
								  :total="total"
								  @current-change="handlePage"
								  >
								</el-pagination>
							</div>
							
						</div>
						
						
						<!-- <div class="neirong_line_right">
							<AdverRightCus></AdverRightCus>
						</div> -->
					</div>
					
				</div>
			</el-main>
			
			<el-footer>
				<FooterCus></FooterCus>
			</el-footer>
			
		</el-container>
	</div>
</template>

<script>
	import HeaderCus from '../components/header.vue'
	import FooterCus from '../components/footer.vue'
	import AdverRightCus from '../components/adverRight.vue'
	export default {
		components: {
			HeaderCus,
			FooterCus,
			AdverRightCus,
		},
		data() {
			return {
				list_prov: [],
				list_city: [],
				list_prov_type: ['primary', ],
				
				list_lingyu: [],
				list_lingyu_type: ['primary', ],
				
				list_year: [],
				list_year_type: ['primary', ],
				
				is_show_month: false,
				list_month: [],
				list_month_type: ['primary', ],
				
				list_fx_leixing: [],
				list_fx_leixing_type: ['primary', ],
				
				is_show_empty: false,
				prov_text: '选择省份', // 用户选择的省份名
				city_text: '选择地市', // 用户选择的城市名
				prov_val: 0, // 用户选择的省份值
				city_val: 0, // 用户选择的城市值
				lingyu_val: 0, // 用户选择的领域
				year_val: 0, //用户选择的年份
				month_val: 0, // 用户选择的月份
				fx_leixing_val: 0, // 用户选择的风险关键词类型值
				keyword: '', // 搜索关键词
				list_record: [], // 数据列表
				pi: 1, // 当前页码
				total: 0, //数据总数
				
				fullscreenLoading: false,
				
				list_wenda_kw: [],
				
				filter_type_id: 0,
				
				
				
			}
		},
		
		created() {
			this.filter_type_id = this.$route.query.typeid;
		},
		
		mounted() {
			this.$router.beforeEach((to, from, next) => {
				// console.log(to, from)
				if (to.meta.title) {
					document.title = to.meta.title
				}
				next()
			})
			
			this.loadDictLingyu()
			this.loadDictYear()
			this.loadDictMonth()
			this.loadProv()
			// this.loadCity('37') // 点击省份后触发加载城市
			// this.loadDictFxleixing() // 加载搜索条件风险因素类型 问询答复暂时没有类型，该数据暂时不用
			
			this.loadWendaKw() // 加载问询答复关键词
			
			this.doSearch(1) // 加载列表数据

			this.checkLogin() // 检查是否登录2025年12月初
		},
		
		methods: {
			// web配置数据链接跳转
			toUrl(url) {
				// console.log(url)
				if (url.indexOf('http') > -1) {
					location.href = url
				} else {
					// this.$router.push({path: url})
					let route_data = this.$router.resolve({path: url})
					// console.log(route_data)
					window.open(route_data.href, '_blank')
				}
			},
			
			// 数据统计可能用不到该方法了，直接toUrl到标杆企业即可，最后看没用的话就删掉
			toDetail(com_id, daqu_id, mokuai_id) {
				console.log('com_id:' + com_id, 'daqu_id:' + daqu_id, 'mokuai_id:' + mokuai_id)
			},
			
			// 加载搜索数据，flag约定传值1或-1，flag为标记是否第1页，传1则第1页，传-1则不改变翻页值（使用已有第x页的值）
			doSearch(flag) {
				this.fullscreenLoading = true
				this.list_record = [] // 先设置成空有个视觉切换效果
				if (flag == 1) {
					this.pi = 1
				}
				let url = this.$common.apiUrl + 'pub_company_base/clientSearchStatisWendaFilter'
				let client_data_json = {
					prov: this.prov_val,
					city: this.city_val,
					lingyu: this.lingyu_val,
					year: this.year_val,
					month: this.month_val,
					fxleixing: this.fx_leixing_val,
					keyword: this.keyword,
					pi: this.pi,
					filter_type_id: this.filter_type_id,
				}
				let client_data = this.$qs.stringify(client_data_json)
				this.$axios.post(url, client_data).then((res)=>{
					console.log(res.data)
					this.fullscreenLoading = false
					this.list_record = res.data.data.rows
					this.total = res.data.data.total
					if (this.list_record == 0) {
						this.is_show_empty = true
					} else {
						this.is_show_empty = false
					}
				})
			},
			
			// 清空搜索框时
			clearInput() {
				if (this.keyword == '') {
					this.doSearch(1)
				}
			},
			
			// 点击分页触发事件
			handlePage(page) {
				// console.log(page)
				this.pi = page
				this.doSearch(-1)
				document.documentElement.scrollTop = 0;
			},
			
			// 加载字典数据（行业领域）
			loadDictLingyu() {
				let url = this.$common.apiUrl + 'sys_dict_data/listByType/pub_dict_hangyelingyu'
				this.$axios.get(url).then((res)=>{
					// console.log(res)
					this.list_lingyu = res.data.data
					// 绑定样式数组
					this.list_lingyu.forEach((item, index) => {
						this.list_lingyu_type.push('info')
					})
				})
			},
			
			// 加载字典数据（年份）
			loadDictYear() {
				let url = this.$common.apiUrl + 'sys_dict_data/listByType/pub_dict_apply_year'
				this.$axios.get(url).then((res)=>{
					// console.log(res)
					this.list_year = res.data.data
					// 绑定样式数组
					this.list_year.forEach((item, index) => {
						this.list_year_type.push('info')
					})
				})
			},
			
			// 加载字典数据（月份）
			loadDictMonth() {
				let url = this.$common.apiUrl + 'sys_dict_data/listByType/pub_dict_apply_month'
				this.$axios.get(url).then((res)=>{
					// console.log(res)
					this.list_month = res.data.data
					// 绑定样式数组
					this.list_month.forEach((item, index) => {
						this.list_month_type.push('info')
					})
				})
			},
			
			// 加载省份
			loadProv() {
				let url = this.$common.apiUrl + 'pub_region/listProv'
				this.$axios.get(url).then((res)=>{
					// console.log(res)
					this.list_prov = res.data.data
				})
			},
			
			// 加载地市
			loadCity(provid) {
				let url = this.$common.apiUrl + 'pub_region/listCity/' + provid
				this.$axios.get(url).then((res)=>{
					// console.log(res)
					this.list_city = res.data.data
				})
			},
			
			// 加载风险因素关键词类型字典（搜索条件）
			loadDictFxleixing() {
				let url = this.$common.apiUrl + 'sys_dict_data/listByType/pub_dict_keyword_type'
				this.$axios.get(url).then((res)=>{
					// console.log(res)
					res.data.data.forEach((item, index) => {
						if (item.dictLabel.indexOf('风险因素关键词') > -1) {
							item.dictLabel = item.dictLabel.replace('数据统计-风险因素关键词-', '')
							this.list_fx_leixing.push(item)
						}
					})
					// 绑定样式数组
					this.list_fx_leixing.forEach((item, index) => {
						this.list_fx_leixing_type.push('info')
					})
				})
			},
			
			// 选择省份
			selectProv(command) {
				// console.log(command)
				if (command == 0) {
					this.prov_val = 0
					this.prov_text = '选择省份'
					this.$set(this.list_prov_type, 0, 'primary')
				} else if (command > 0) {
					this.list_prov.forEach((item, index) => {
						if (item.id == command) {
							// console.log(item.name);
							this.prov_val = item.id
							this.prov_text = item.name
							this.loadCity(this.prov_val) // 加载下级城市
							this.$set(this.list_prov_type, 0, 'info')
							this.city_val = 0
							this.city_text = '选择城市'
						}
					})
				}
				
				this.doSearch(1)
			},
			
			// 选择城市
			selectCity(command) {
				if (command == 0) {
					this.city_val = 0
					this.city_text = '选择城市'
				} else if (command > 0) {
					this.list_city.forEach((item, index) => {
						if (item.id == command) {
							// console.log(item.name);
							this.city_val = item.id
							this.city_text = item.name
						}
					})
				}
				
				this.doSearch(1)
			},
			
			// 点击地区条件（这个略特殊，只有“不限”按钮触发）
			clickDiqu(index, id) {
				if (index == 0) {
					this.$set(this.list_prov_type, 0, 'primary')
					this.prov_val = 0
					this.prov_text = '选择省份'
					this.city_val = 0
					this.city_text = '选择城市'
				}
				
				this.doSearch(1)
			},
			
			// 点击领域条件
			clickLingyu(index, id) {
				console.log(index, id)
				this.list_lingyu_type.forEach((item, idx)=>{
					if (index == idx) {
						this.$set(this.list_lingyu_type, idx, 'primary')
					} else {
						this.$set(this.list_lingyu_type, idx, 'info')
					}
				})
				this.lingyu_val = id
				
				this.doSearch(1)
			},
			
			// 点击时间条件（年）
			clickYear(index, id) {
				// console.log(index, id)
				this.list_year_type.forEach((item, idx)=>{
					if (index == idx) {
						this.$set(this.list_year_type, idx, 'primary')
					} else {
						this.$set(this.list_year_type, idx, 'info')
					}
				})
				this.year_val = id
				
				if (index == 0) {
					this.is_show_month = false
					this.month_val = 0
				} else {
					this.is_show_month = true
					this.clickMonth(0, 999999)
				}
				
				this.doSearch(1)
			},
			
			// 点击月份条件（月）
			clickMonth(index, id) {
				// console.log(index, id)
				this.list_month_type.forEach((item, idx)=>{
					if (index == idx) {
						this.$set(this.list_month_type, idx, 'primary')
					} else {
						this.$set(this.list_month_type, idx, 'info')
					}
				})
				
				if (id == 999999) {
					this.month_val = 0
				} else {
					this.month_val = id
					this.doSearch(1) // 传递特殊标记，只有在id不等于999999时重新加载数据
				}
			},
			
			// 点击风险因素关键词类型字典（搜索条件）  暂时去掉了
			clickFxleixing(index, id) {
				console.log(index, id)
				this.list_fx_leixing_type.forEach((item, idx)=>{
					if (index == idx) {
						this.$set(this.list_fx_leixing_type, idx, 'primary')
					} else {
						this.$set(this.list_fx_leixing_type, idx, 'info')
					}
				})
				this.fx_leixing_val = id
				
				this.loadFengxianKw()
				
				this.doSearch(1)
			},
			
			// 加载问询答复关键词
			loadWendaKw() {
				let url = ''
				url = this.$common.apiUrl + 'pub_keyword_ipofile/listWendaKw'
				this.$axios.get(url).then((res)=>{
					// console.log(res)
					this.list_wenda_kw = res.data.data
				})
			},

			// 判断用户是否登陆 2025年12月初，高莎莎发信息用户未登录，不显示详情，跳转至登录页
			checkLogin() {
				let cur_user = JSON.parse(localStorage.getItem('cur_user'));
				if (cur_user) {

				} else {
					this.$message.error('用户未登录，无法继续浏览，请登录会员后浏览和下载')
					setTimeout(() => {
						this.$router.push({path: '/login'})
					}, 2500)
					return;
				}
			},
			
			
		}
	}
</script>

<style scoped>
.el-dropdown-link {
	cursor: pointer;
	color: #409EFF;
}
.el-icon-arrow-down {
	font-size: 12px;
}
.el-tag--small {
	margin: 0 10px;
}
.el-dropdown {
	margin: 0 10px;
}
</style>